export interface UserCountResult {
  userCount: number;
  appId: string;
  subscriptionId?: string;
  date: string;
}
